export class InputDto {
  fieldName: string;
  fieldValue: string;
  rawColumn: string;
  rawValue: any;
  inputType: string;
  fieldValueFalse: string;
  fieldValueTrue: string;
  isLock: boolean;
  isPower: boolean;
  isDoor: boolean;

  constructor(data: Partial<InputDto> = {}) {
    this.fieldName = data?.fieldName ?? '';
    this.fieldValue = data?.fieldValue ?? '';
    this.rawColumn = data?.rawColumn ?? '';
    this.rawValue = data?.rawValue;
    this.inputType = data?.inputType ?? '';
    this.fieldValueFalse = data?.fieldValueFalse ?? '';
    this.fieldValueTrue = data?.fieldValueTrue ?? '';
    this.isLock = data?.isLock ?? false;
    this.isPower = data?.isPower ?? false;
    this.isDoor = data?.isDoor ?? false;
  }
}